import { Input as AntInput } from 'antd'
import type { FC, ReactNode, RefObject } from 'react'

import { Label } from 'common/components/Label/Label'

import type { AppointmentIssuesSelection } from '../MedicalIssuesField'
import { MedicalIssuesField } from '../MedicalIssuesField'
import styles from './ehrAppointmentV2.module.scss'

type Props = {
  comments: string
  siteId: string
  patientId: number | null
  appointmentId: number | null
  mode: 'create' | 'edit'
  disabled: boolean
  selectionRef: RefObject<AppointmentIssuesSelection>
  onCommentsChange: (comments: string) => void
  commentsLockLine: string | null
  complaints: ReactNode
}

export const ClinicalPanel: FC<Props> = ({
  comments,
  siteId,
  patientId,
  appointmentId,
  mode,
  disabled,
  selectionRef,
  onCommentsChange,
  commentsLockLine,
  complaints,
}) => (
  <div className={styles.clinical}>
    <div className={styles.clinicalColumn}>
      <div className={styles.commentsStack}>
        <Label label='Comments' id='appointment-comments' />
        <AntInput.TextArea
          id='appointment-comments'
          value={comments}
          rows={2}
          disabled={disabled || !!commentsLockLine}
          placeholder='Enter any additional comments...'
          onChange={(event) => onCommentsChange(event.target.value)}
        />
        {commentsLockLine && <span className={styles.resultsNote}>{commentsLockLine}</span>}
      </div>
      <div className={styles.complaintsSlot}>{complaints}</div>
    </div>

    <div className={styles.clinicalColumn}>
      <MedicalIssuesField
        mode={mode}
        siteId={siteId}
        patientId={patientId}
        appointmentId={appointmentId}
        selectionRef={selectionRef}
        disabled={disabled}
      />
    </div>
  </div>
)
